<template>
	<div>
		<el-dialog
			title="提示"
			:visible.sync="wordDialog"
			width="420px"
			:before-close="handleClose"
			:modal="false"
			custom-class="senWord_dialog"
			:close-on-click-modal="false"
		>
			<div class="warn">
				<i class="el-icon-warning"></i>系统检测到您的内容包含敏感词,请修改后发送
			</div>
			<div class="body">
				<div v-for="(item, index) in wordData" :key="index">
					<div v-if="item.sort == 1">
						<span class="title">敏感词</span>
						<el-tooltip
							popper-class="senWord_tooltip"
							effect="dark"
							content="敏感词：是指带有敏感政治色彩与倾向、色情倾向、暴力倾向、不文明倾向、不健康倾向等特殊词汇,通常这些词都是不能够在网站中出现的。"
							placement="top-start"
						>
							<i class="el-icon-question blueStyle"></i>
						</el-tooltip>
					</div>
					<div v-if="item.sort == 0">
						<span class="title">极限词</span>
						<el-tooltip
							popper-class="senWord_tooltip"
							effect="dark"
							content="极限词：是一种表极限的词汇。《中华人民共和国广告法》已由中华人民共和国第十二届全国人民代表大会常务委员会第十四次会议于公布，自2015年9月1日起施行"
							placement="top-start"
						>
							<i class="el-icon-question blueStyle"></i>
						</el-tooltip>
					</div>
					<div v-if="item.sort == 2">
						<span class="title">侵权词</span>
						<el-tooltip
							popper-class="senWord_tooltip"
							effect="dark"
							content="侵权词：侵犯知识产权比如发明、外观设计、文学和艺术作品，以及在商业中使用的标志、名称、图像；知识产权是指人类智力劳动产生的智力劳动成果所有权。它是依照各国法律赋予符合条件的著作者、发明者或成果拥有者在一定期限内享有的独占权利，一般认为它包括版权(著作权)和工业产权。"
							placement="top-start"
						>
							<i class="el-icon-question blueStyle"></i>
						</el-tooltip>
					</div>
					<div class="content">{{ item.childs.join('、') }}</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleClose">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
	data() {
		return {};
	},
	components: {},
	computed: {
		...mapGetters(['wordDialog', 'wordData']),
	},
	methods: {
		handleClose() {
			this.$store.commit('SET_WORDDIALOG', false);
		},
	},
};
</script>
<style lang="scss" scoped>
.warn {
	padding: 5px 10px;
	background-color: #fef0f0;
	color: #f56c6c;
	border-radius: 5px;
}
.blueStyle {
	color: #409eff;
	cursor: pointer;
}
.title {
	color: #333;
	font-weight: bold;
	margin-right: 5px;
}
.content {
	padding: 20px 0px;
}
.body {
	padding-top: 25px;
}
</style>
<style lang="scss">
.senWord_dialog {
	.el-dialog__body {
		padding-top: 5px !important;
	}
}
.senWord_tooltip {
	width: 330px;
}
</style>
